import _ from 'underscore';
import { BaseSchemaProcessor } from './base-schema-processor';

export class ProductSchemaProcessor extends BaseSchemaProcessor {
  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = super.updateEntitySchemaForFeatures(entitySchema);

    const MPNProperty = updatedSchema.properties.MPN;

    if (MPNProperty && MPNProperty.alias != null) {
      MPNProperty.title = MPNProperty.alias;
    }

    if (this.Permissions.IsProductsTabV2Enabled) {
      const titleProperty = updatedSchema.properties.Title;
      if (titleProperty) {
        titleProperty.operators.push('eq');
      }

      if (updatedSchema.properties.PerformanceMetricsViewThroughConversions) {
        updatedSchema.properties.PerformanceMetricsViewThroughConversions.filterable = false;
      }

      if (updatedSchema.properties.PerformanceMetricsViewThroughConversionsRevenue) {
        // eslint-disable-next-line max-len
        updatedSchema.properties.PerformanceMetricsViewThroughConversionsRevenue.filterable = false;
      }

      if (updatedSchema.properties.PerformanceMetricsViewThroughConversionsCPA) {
        updatedSchema.properties.PerformanceMetricsViewThroughConversionsCPA.filterable = false;
      }

      if (updatedSchema.properties.PerformanceMetricsViewThroughConversionsReturnOnAdSpend) {
        // eslint-disable-next-line max-len
        updatedSchema.properties.PerformanceMetricsViewThroughConversionsReturnOnAdSpend.filterable = false;
      }

      if (updatedSchema.properties.PerformanceMetricsViewThroughConversionsRate) {
        updatedSchema.properties.PerformanceMetricsViewThroughConversionsRate.filterable = false;
      }

      if (updatedSchema.properties.PerformanceMetricsQuantityBought) {
        updatedSchema.properties.PerformanceMetricsQuantityBought.filterable = false;
      }
    }

    const conditionProperty = updatedSchema.properties.Condition;
    if (conditionProperty) {
      conditionProperty.chooseType = 'radio';
      conditionProperty.operators = ['eq'];
    }

    const channelProperty = updatedSchema.properties.Channel;
    if (channelProperty) {
      channelProperty.chooseType = 'radio';
      channelProperty.operators = ['eq'];
    }

    const channelExclusivityProperty = updatedSchema.properties.ChannelExclusivity;

    if (channelExclusivityProperty) {
      channelExclusivityProperty.chooseType = 'radio';
      channelExclusivityProperty.operators = ['eq'];
    }

    const omitProperties = ['Language', 'Labels', 'SellerName', 'UniqueId'];
    updatedSchema.properties = _.omit(updatedSchema.properties, omitProperties);

    return updatedSchema;
  }

  formatFilterValue(value) {
    if (Array.isArray(value)) {
      return value[0];
    }
    return value;
  }

  updateOdataOptions(odataOptions) {
    super.updateOdataOptions(odataOptions);

    _.extendOwn(odataOptions.custom, {
      Condition: {
        eq: (value) => {
          const condition = this.formatFilterValue(value).split("'")[1];
          const url = `Condition eq '${condition}'`;

          return url;
        },
      },
      Channel: {
        eq: (value) => {
          const channel = this.formatFilterValue(value).split("'")[1];
          const url = `Channel eq '${channel}'`;

          return url;
        },
      },
      ChannelExclusivity: {
        eq: (value) => {
          const channelExclusivity = this.formatFilterValue(value).split("'")[1];
          const url = `ChannelExclusivity eq '${channelExclusivity}'`;

          return url;
        },
      },
    });

    return odataOptions;
  }
}
